import { navigate } from "gatsby";
import React from "react";

import whiteLogo from "../images/logo-white.png";
import * as styles from "../styles/HeaderLogo.module.css";

const HeaderLogo = () => {
  return (
    <div className={styles.container} onClick={() => navigate("/")}>
      <img src={whiteLogo} className={styles.logo} alt={"Nexus Health Logo"} />
      <div className={styles.logo_text_div}>
        <p className={styles.logo_text}>
          Nexus
          <br />
          Health
        </p>
      </div>
    </div>
  );
};

export default HeaderLogo;
